<template>
  <div class="monitor-summary">
    <button v-for="tile in tiles" :key="tile.key" type="button"
            class="monitor-summary__tile" :class="['monitor-summary__tile--' + (tile.tone || 'neutral'), { 'monitor-summary__tile--active': tile.key == active, 'monitor-summary__tile--static': !tile.filter }]"
            :disabled="!tile.filter"
            v-b-tooltip.hover :title="tile.filter ? (tile.key == active ? 'Quitar filtro' : 'Filtrar: ' + tile.label) : ''"
            @click="$emit('select', tile.key == active ? null : tile.key)">
      <span class="monitor-summary__icon"><AppIcon :name="tile.icon" /></span>
      <span class="monitor-summary__body">
        <span class="monitor-summary__value">{{tile.value}}</span>
        <span class="monitor-summary__label">{{tile.label}}</span>
      </span>
    </button>
  </div>
</template>

<script>
  // fila de indicadores del listado; los que tienen filter se pueden clickear
  // para filtrar (y volver a clickear para quitar el filtro)
  export default {
    props: {
      tiles: { type: Array, required: true }, // [{key, label, value, icon, tone, filter}]
      active: { type: String, default: null },
    },
  }
</script>

<style scoped>
  .monitor-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
  }

  .monitor-summary__tile {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid var(--app-color-border, #e3e6ea);
    border-radius: 10px;
    background: var(--app-color-surface, #fff);
    text-align: left;
    cursor: pointer;
    transition: border-color .15s, box-shadow .15s;
  }

  .monitor-summary__tile:hover:not(:disabled) {
    border-color: var(--app-color-border-strong, #ced4da);
    box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
  }

  .monitor-summary__tile--static {
    cursor: default;
  }

  .monitor-summary__tile--active {
    border-color: var(--app-color-primary, #007bff);
    box-shadow: 0 0 0 2px var(--app-color-primary-soft, #eaf2ff);
  }

  .monitor-summary__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 34px;
    height: 34px;
    border-radius: 9px;
    font-size: 18px;
  }

  .monitor-summary__body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .monitor-summary__value {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.1;
  }

  .monitor-summary__label {
    color: var(--app-color-text-muted, #6c757d);
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .monitor-summary__tile--neutral .monitor-summary__icon { background: var(--app-color-surface-subtle, #f1f3f5); color: var(--app-color-text-secondary, #495057); }
  .monitor-summary__tile--success .monitor-summary__icon { background: var(--app-color-success-soft, #e8f5e9); color: var(--app-color-success, #28a745); }
  .monitor-summary__tile--warning .monitor-summary__icon { background: var(--app-color-warning-soft, #fff8e1); color: var(--app-color-warning-hover, #b8860b); }
  .monitor-summary__tile--danger .monitor-summary__icon { background: var(--app-color-danger-soft, #fdecea); color: var(--app-color-danger, #dc3545); }
  .monitor-summary__tile--info .monitor-summary__icon { background: var(--app-color-primary-soft, #eaf2ff); color: var(--app-color-primary-active, #0056b3); }
</style>
